/* ===== Onboarding — „Aplicația locației tale” (4 pași, swipe, fără scroll) ===== */
import { showPage } from './routing.js?v=83.79';

const DONE_KEY = 'sj_onboarding_done';

export function hasSeenOnboarding() {
  try {
    return localStorage.getItem(DONE_KEY) === '1';
  } catch (_) {
    return false;
  }
}

function markDone() {
  try {
    localStorage.setItem(DONE_KEY, '1');
  } catch (_) {
    /* ignore */
  }
}

let step = 0;
let bound = false;

function root() {
  return document.getElementById('sjOnb');
}

function slides() {
  return Array.from(document.querySelectorAll('#sjOnbTrack .sjo-slide'));
}

function render() {
  const r = root();
  const list = slides();
  if (!r || !list.length) return;
  step = Math.max(0, Math.min(step, list.length - 1));
  r.dataset.step = String(step);
  const track = document.getElementById('sjOnbTrack');
  if (track) track.style.transform = `translate3d(${-step * 100}%, 0, 0)`;
  list.forEach((s, i) => {
    s.setAttribute('aria-hidden', i === step ? 'false' : 'true');
    s.classList.toggle('is-active', i === step);
  });
  const dots = document.getElementById('sjOnbDots');
  if (dots) {
    if (dots.children.length !== list.length) {
      dots.replaceChildren(
        ...list.map((_, i) => {
          const d = document.createElement('button');
          d.type = 'button';
          d.setAttribute('role', 'tab');
          d.setAttribute('aria-label', `Pasul ${i + 1}`);
          d.dataset.onbDot = String(i);
          return d;
        })
      );
    }
    Array.from(dots.children).forEach((d, i) => {
      d.classList.toggle('is-on', i === step);
      d.setAttribute('aria-selected', i === step ? 'true' : 'false');
    });
  }
  const last = step === list.length - 1;
  const next = document.getElementById('sjOnbNext');
  if (next) next.textContent = last ? 'Începe gratuit' : 'Mai departe';
  const alt = document.getElementById('sjOnbAlt');
  if (alt) alt.hidden = !last;
  const skip = r.querySelector('.sjo-skip');
  if (skip) skip.style.visibility = last ? 'hidden' : 'visible';
}

function go(i) {
  step = i;
  render();
}

function finish(target) {
  markDone();
  showPage(target === 'register' ? 'registerPage' : 'loginPage');
}

function bind() {
  if (bound) return;
  bound = true;

  document.addEventListener('click', (e) => {
    const t = e.target.closest?.('[data-onb], [data-onb-dot]');
    if (!t) return;
    if (t.dataset.onbDot != null) {
      go(Number(t.dataset.onbDot));
      return;
    }
    const a = t.dataset.onb;
    if (a === 'open') {
      e.preventDefault();
      openOnboarding();
    } else if (a === 'next') {
      if (step >= slides().length - 1) finish('register');
      else go(step + 1);
    } else if (a === 'login') {
      finish('login');
    }
  });

  // Swipe stânga/dreapta
  let x0 = null;
  let y0 = null;
  document.addEventListener(
    'touchstart',
    (e) => {
      if (!e.target.closest?.('#sjOnbTrack')) return;
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    },
    { passive: true }
  );
  document.addEventListener(
    'touchend',
    (e) => {
      if (x0 == null) return;
      const dx = e.changedTouches[0].clientX - x0;
      const dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0 && step < slides().length - 1) go(step + 1);
      if (dx > 0 && step > 0) go(step - 1);
    },
    { passive: true }
  );

  document.addEventListener('keydown', (e) => {
    if (!document.getElementById('onb1')?.classList.contains('visible')) return;
    if (e.key === 'ArrowRight' && step < slides().length - 1) go(step + 1);
    if (e.key === 'ArrowLeft' && step > 0) go(step - 1);
  });
}

/** Deschide onboarding-ul de la început (și din „Descoperă cum funcționează”). */
export function openOnboarding() {
  bind();
  step = 0;
  render();
  showPage('onb1');
}

// Compatibilitate cu apelurile vechi
export function nextOnboarding() {
  bind();
  if (step < slides().length - 1) go(step + 1);
}

export function finishOnboarding() {
  finish('login');
}

if (typeof document !== 'undefined') {
  const init = () => {
    bind();
    render();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}

window.nextOnboarding = nextOnboarding;
window.finishOnboarding = finishOnboarding;
window.openOnboarding = openOnboarding;
